// Where a person lands.
//
// HOME_URL is Stride's landing page: what a fresh sign-in opens, what the
// brand logo opens, and what is left when the last tab is closed (it used
// to be Folders, which opened a "Default Folder" nobody had asked for).
//
// A link followed while signed OUT (a work item's /KEY address in a mail,
// say) is remembered by the auth guard and taken once after the sign-in,
// so the link still lands where it pointed instead of on Home.

export const HOME_URL = '/home';
export const HOME_TITLE = 'Home';

const LANDING_KEY = 'stride:landingAfterSignIn';

// A same-origin in-app path, or null. Never an auth landing, never '/'
// (the sign-in page itself), never protocol-relative ('//host').
export function safeLandingPath(path, origin) {
  if (!path || typeof path !== 'string') return null;
  try {
    const u = new URL(path, origin);
    if (u.origin !== origin) return null;
    const p = u.pathname + u.search + u.hash;
    if (!p.startsWith('/') || p.startsWith('//')) return null;
    if (u.pathname === '/' || u.pathname.startsWith('/auth/')) return null;
    return p;
  } catch {
    return null;
  }
}

function store() {
  try { return window.sessionStorage; } catch { return null; }
}

// Remember where a signed-out person was going (the auth guard calls this).
export function rememberLanding(path) {
  const safe = safeLandingPath(path, window.location.origin);
  const s = store();
  if (!s) return;
  try {
    if (safe) s.setItem(LANDING_KEY, safe);
  } catch { /* storage full or blocked — the person lands on Home */ }
}

// Where to go after signing in: the remembered link (taken once), else Home.
export function takeLandingAfterSignIn() {
  const s = store();
  let path = null;
  try {
    path = s ? s.getItem(LANDING_KEY) : null;
    if (s) s.removeItem(LANDING_KEY);
  } catch { path = null; }
  return safeLandingPath(path, window.location.origin) || HOME_URL;
}
